import {useLocation, useNavigate} from "react-router-dom";

export const useTabNavigation = () => {
  const {state} = useLocation();
  const {activeTab} = state || {};
  const navigate = useNavigate();

  const handleTabChange = (tab) => {
    navigate(location.pathname, {
      state: {
        activeTab: tab,
      },
    });
  };

  return {activeTab, handleTabChange};
};
